<template>
  <b-input
    v-model="form.name"
    :error-messages="getErrorMessages(v$.name)"
    label="Назва"
    placeholder="Введіть назву"
    @blur="v$.name.$touch()" />
  <b-select
    v-model="form.fieldType"
    :error-messages="getErrorMessages(v$.fieldType)"
    :items="$directory.get('fieldTypes')"
    :loading="$loading.isLoading('fieldTypes')"
    label="Тип поля"
    @blur="v$.fieldType.$touch()"
    @focus="$directory.fill('fieldTypes')"
    @update:model-value="onFieldTypeChange" />
  <v-checkbox v-model="form.isSystem" label="Системне поле" />

  <div v-if="form.fieldType === 'upload'">
    <v-combobox
      v-model="form.settingsJson.allowedExtensions"
      :items="commonExtensions"
      chips
      clearable
      hint="Наприклад: pdf, docx, png. Залиште порожнім — дозволено всі."
      label="Дозволені типи файлів"
      multiple
      persistent-hint
      placeholder="Оберіть або введіть розширення" />
    <div class="text-caption text-medium-emphasis mb-1">
      Попередній вигляд поля завантаження
    </div>
    <FileDropper
      :select-options="{
        multiple: false,
        accept: form.settingsJson.allowedExtensions.map(ext => `.${ext}`),
      }"
      dropper-variant="blue-label"
      style="pointer-events: none; opacity: 0.7" />
  </div>

  <div v-if="form.fieldType === 'integer' || form.fieldType === 'decimal'">
    <b-input
      v-model.number="form.settingsJson.min"
      clearable
      label="Мінімальне значення"
      placeholder="Без обмежень"
      type="number" />
    <b-input
      v-model.number="form.settingsJson.max"
      clearable
      label="Максимальне значення"
      placeholder="Без обмежень"
      type="number" />
  </div>
</template>
<script>
import { reactive } from 'vue'
import { required, useVuelidate } from '@/plugins'
import { getErrorMessages } from '@/utils/helpers'
import FileDropper from '@/components/filesUploader/FileDropper.vue'
import {
  fieldDefinitionCreate,
  fieldDefinitionUpdate,
} from '@/requests/fieldDefinition'
import { keepArray } from 'best-modules/utils'

export default {
  name: 'FieldDefinition',
  components: { FileDropper },
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getErrorMessages },
  setup(props) {
    const isUpdate = props.dialog.action === 'update'
    const itemData = props.dialog.dialogData?.itemData

    const commonExtensions = [
      'pdf',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'png',
      'jpg',
      'jpeg',
      'svg',
      'zip',
      'rar',
    ]

    const defaultSettings = () => ({
      allowedExtensions: [],
      min: null,
      max: null,
    })

    const existingSettings = itemData?.settingsJson || {}

    const form = reactive({
      name: itemData?.name || null,
      fieldType: itemData?.fieldType || null,
      isSystem: itemData?.isSystem || false,
      settingsJson: {
        ...defaultSettings(),
        ...existingSettings,
      },
    })

    const onFieldTypeChange = () => {
      form.settingsJson = defaultSettings()
    }

    const rules = {
      name: { required },
      fieldType: { required },
    }

    const v$ = useVuelidate(rules, form)

    const submit = () => {
      const payload = {
        name: form.name,
        fieldType: form.fieldType,
        isSystem: form.isSystem,
        settingsJson: buildSettings(),
      }

      if (isUpdate) {
        return fieldDefinitionUpdate(itemData.id, payload)
      } else {
        return fieldDefinitionCreate(payload)
      }
    }

    const buildSettings = () => {
      if (form.fieldType === 'upload') {
        return {
          allowedExtensions: keepArray(
            form.settingsJson.allowedExtensions?.map(e =>
              e.replace(/^\./, '').toLowerCase()
            )
          ),
        }
      }
      if (form.fieldType === 'integer' || form.fieldType === 'decimal') {
        return {
          min: form.settingsJson.min !== '' ? form.settingsJson.min : null,
          max: form.settingsJson.max !== '' ? form.settingsJson.max : null,
        }
      }
      return null
    }

    return {
      form,
      v$,
      submit,
      commonExtensions,
      onFieldTypeChange,
      validationScope: 'fieldDefinition',
    }
  },
}
</script>
